export default "__VITE_ASSET__54753d49__"